import React from 'react';
import { Code2, Database, Cloud, Smartphone, Globe, Shield } from 'lucide-react';
import { useScrollReveal } from '@/hooks/use-scroll-reveal';

const technologies = [
  {
    title: 'Frontend',
    description: 'Modern, responsive interfaces',
    icon: Globe,
  },
  {
    title: 'Mobile',
    description: 'Native iOS and Android',
    icon: Smartphone,
  },
  {
    title: 'Backend',
    description: 'Scalable server architecture',
    icon: Database,
  },
  {
    title: 'Cloud',
    description: 'Deployment and infrastructure',
    icon: Cloud,
  },
  {
    title: 'APIs',
    description: 'Third-party integrations',
    icon: Code2,
  },
  {
    title: 'Security',
    description: 'Data protection',
    icon: Shield,
  }
];

export const TechnologyShowcase = () => {
  const { elementRef, getRevealStyle } = useScrollReveal();

  return (
    <section className="tech-section-professional">
      <div className="container-professional">
        <div className="section-header-professional">
          <div className="micro-label-professional">MODERN STACK</div>
          <h2 className="heading-section">Technology we use</h2>
          <p className="text-body">
            Proven tools and frameworks for reliable, scalable solutions
          </p>
        </div>

        <div ref={elementRef} className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 max-w-7xl mx-auto">
          {technologies.map((tech, index) => (
            <div 
              key={tech.title} 
              className="group relative overflow-hidden"
              style={getRevealStyle(index)}
            >
              <div className="bg-white/[0.04] backdrop-blur-md border border-white/[0.14] rounded-2xl p-6 min-h-[200px] text-center flex flex-col items-center justify-center transition-all duration-300 hover:-translate-y-2 hover:border-[rgba(0,229,255,0.4)] hover:shadow-lg hover:bg-white/[0.07]">
                {/* Shimmer Effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                
                <tech.icon className="w-12 h-12 text-primary mb-4 relative z-10" strokeWidth={1.5} />
                
                <h3 className="text-lg font-semibold text-white mb-2 relative z-10">
                  {tech.title}
                </h3>
                
                <p className="text-sm text-white/90 leading-snug relative z-10">
                  {tech.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};